export default __webpack_public_path__ + "static/soehne-web-dreiviertelfett-kursiv-d472f04224487cbd875ac955e42bebfe.eot";